import { render, staticRenderFns } from "./serviceSet.vue?vue&type=template&id=b79776d8&scoped=true&"
import script from "./serviceSet.vue?vue&type=script&lang=js&"
export * from "./serviceSet.vue?vue&type=script&lang=js&"
import style0 from "./serviceSet.vue?vue&type=style&index=0&id=b79776d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79776d8",
  null
  
)

export default component.exports